module.exports = __webpack_public_path__ + "static/media/locked-padlock.decaf8d4.svg";